(function ($) {
  $(function () {
    $('.toc__button').on('click', function () {
      if ($(this).attr('aria-expanded') == 'false') {
        $(this).attr('aria-expanded', 'true');
        $(this).next('.toc__list').slideDown();
      } else {
        $(this).attr('aria-expanded', 'false');
        $(this).next('.toc__list').slideUp();
      }
    })
  });
})(jQuery);


// WEBPACK FOOTER //
// ./assets/js/toc.js